import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  ToastController,
  ModalController
} from "ionic-angular";
import { DatabaseProvider } from "../../providers/database/database";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/mergeMap";
import { AuthProvider } from "../../providers/auth/auth";
import { AdminClinicDetailsPage } from "../admin-clinic-details/admin-clinic-details";
import { HomePage } from "../home/home";
import { AdminClinicsAddPage } from "../admin-clinics-add/admin-clinics-add";

@IonicPage()
@Component({
  selector: "page-admin-clinics",
  templateUrl: "admin-clinics.html"
})
export class AdminClinicsPage {

  public clinicList: Observable<any[]>;
  clinic_name: string;
  clinic_id: string;
  user: any;
  clinic: any = {};

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController
  ) {
    this.auth.getCurrentUser().then(user => {
      this.user = user;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.clinicList = this.database
      .getClinics()
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
    });
  }

  ionViewDidLoad() {}

  
  edit(clinic)  {
    let clinicdata = {
      clinic: clinic
    };
    this.navCtrl.push(AdminClinicDetailsPage, clinicdata)
  }

  switchClinic(selected_clinic)  {
    let confirm = this.alertCtrl.create({
      title: "Switch Clinic?",
      message: "Are you sure you want to switch to viewing " + selected_clinic.clinic_name + "?",
      buttons: [
        {
          text: "No",
          handler: () => {
            console.log("Don't switch clinic right now");
          }
        },
        {
          text: "Yes",
          handler: () => {
            let clinic: any = {};
            clinic.clinic_id = selected_clinic.id;
            clinic.clinic_name = selected_clinic.clinic_name;
    
            this.database.updateUser(this.user.id, clinic).then((data) => {
              this.navCtrl.setRoot(HomePage);
            })
            .catch((err) => {
              console.log(err)
            })
   
          }
        }
      ]
    });
    confirm.present();
  }

  presentAddClinicModal() {
    let clinicModal = this.modalCtrl.create(AdminClinicsAddPage, null, {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }

  editClinic(clinic)  {
    let clinicModal = this.modalCtrl.create(AdminClinicsAddPage, {'clinicdata': clinic} , {showBackdrop: true, enableBackdropDismiss: false});
    clinicModal.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-clinics/admin-clinics.ts